export class ScheduleImportError extends Error {
	constructor(public userError: string) {
		super(userError);
	}
}

export function isScheduleImportError(error: ScheduleImportError): error is ScheduleImportError {
	return error.userError !== undefined;
}
